import React, { FC, useEffect, useState } from "react";
import NotificationPopUp from "../../../extras/NotificationPopUp";
import { API_URL } from "../../../../actions/settings";
import { IonCol, IonIcon, IonRow } from "@ionic/react";
import { pencilSharp } from "ionicons/icons";
import EditSavingsDateModal from "../../Modals/EditSavingsDateModal";
import EditBaselineDateModal from "../../Modals/EditBaselineDateModal";

interface IProps {
    id: string | null | undefined;
    hidden:boolean;
};

interface Settings {
        baseline_date: string ,
        savings_date: string ,
        station: string,
        zipcode: string
}

async function regressionSettings(id: any, token: string) {
    return fetch(`${API_URL}/buildings/${id}/degree_days_coefficients/settings`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          res.json().then((err) => {
            NotificationPopUp("Error", err, "Error Getting Data");
          });
        }
      })
      .catch((error) => {
        NotificationPopUp("Error", error.message, "Error Getting Data");
      });
  }

const DegreeDaysRegressionSettings:FC<IProps> = ({id,hidden}) => {
    const [settings,setSettings] = useState<Settings>(
        {
            baseline_date: "",
            savings_date: "",
            station: "",
            zipcode: ""
        }
    )
    const [savingsModal, setSavingsModal] = useState(false)
    const [baselineModal, setBaselineModal] = useState(false)

    const handleSettings = async () => {
        const token = `Token ${(localStorage.getItem("token") || "").slice(
          1,
          -1
        )}`;
        const res = await regressionSettings(id, token);
        setSettings(res);
      };

      useEffect(() => {


        handleSettings();
        // eslint-disable-next-line
      }, [id]);

    return <div hidden={hidden} style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "1em",
      }}>
        <div style={{width:'300px'}}>
            <IonRow>
                <IonCol>Baseline End Date:</IonCol>
                <IonCol>{settings.baseline_date} <IonIcon className="pointer"  onClick={()=>setBaselineModal(true)} src={pencilSharp}></IonIcon></IonCol>
            </IonRow>
            <IonRow>
                <IonCol>Savings Start Date:</IonCol>
                <IonCol>{settings.savings_date} <IonIcon className="pointer" onClick={()=>setSavingsModal(true)} src={pencilSharp}></IonIcon></IonCol>
            </IonRow>
            <IonRow>
                <IonCol>Station ID:</IonCol>
                <IonCol>{settings.station}</IonCol>
            </IonRow>
            <IonRow>
                <IonCol>Zip Code:</IonCol>
                <IonCol>{settings.zipcode}</IonCol>
            </IonRow>
        </div>
        <EditSavingsDateModal opened={savingsModal} setOpened={setSavingsModal} date={settings.savings_date} setData={setSettings} id={id}/>
        <EditBaselineDateModal opened={baselineModal} setOpened={setBaselineModal} date={settings.baseline_date} setData={setSettings} id={id}/>

    </div>
};

export default DegreeDaysRegressionSettings;